import { FixedContainer } from '@calendly/ui/components/fixed-container';
import { IconX } from '@calendly/ui/components/glyphs/IconX';
import { IconButton } from '@calendly/ui/components/icon-button';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const sidebarIsPhoneCss = "s1i2jnb1";
const sidebarIsSlidingInCss = "sqqw1s3";
const sidebarCss = "s1tjazo6";
export const Sidebar = forwardRef((props, ref) => {
  const {
    isSlidingIn
  } = props;
  const isPhone = useDeviceType('isPhone');
  return <FixedContainer ref={ref} {...props} className={classNames(sidebarCss, {
    [sidebarIsPhoneCss]: isPhone,
    [sidebarIsSlidingInCss]: isSlidingIn
  }, props.className)} />;
});
const closeButtonContainerCss = "c1pmoybr";
const CloseButtonContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(closeButtonContainerCss, props.className)} />;
});
export const CloseSidebarButton = ({
  onClick,
  title
}) => <CloseButtonContainer>
    <IconButton onClick={onClick} title={title} size="small">
      <UiIcon icon={IconX} size="small" />
    </IconButton>
  </CloseButtonContainer>;
const sidebarContentCss = "s1px5246";
export const SidebarContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sidebarContentCss, props.className)} />;
});

require("./sidebar.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./sidebar.js");